<template>
  <div></div>
</template>

<style lang="scss" scoped></style>

<script>
export default {
  name: "LogAcessoView",
  mounted() {
    // this.$route.params.id;
  }
};
</script>
